import noPhoto from 'images/noPhoto.png';
import Photo from 'app/shared/models/Photo';

const imageUtils = {
  noImageFound() {
    return [new Photo({ url: noPhoto, noPhoto: true })];
  },

  /**
   * Normalizes image URLs to protocol-relative format to prevent hydration mismatches
   * between server (https://...) and client (//...) rendering
   */
  normalizeImageUrl(url: string | undefined | null): string | undefined | null {
    if (!url || typeof url !== 'string') {
      return url;
    }

    if (url.match(/^https?:\/\//)) {
      return url.replace(/^https?:/, '');
    }

    return url;
  },
};

export default imageUtils;
